export default '/build/641526b8.svg'